import React from "react";
import { Box, Grid } from "@mui/material";
import { AppLayout } from "layout";
import {

    BecomeContentCreatorData,
} from "modules/Setting/components";

type Props = {};

const BecomeContentCreatorContainer = (props: Props) => {

    return (
        <AppLayout>

            <BecomeContentCreatorData />


        </AppLayout>
    );
};

export default BecomeContentCreatorContainer;
